/**
 * SettingsSkeleton Component
 * 
 * Skeleton loading state for Settings page
 */

import { Container, Stack } from '../../../components/primitives';
import { Card, CardHeader, CardContent } from '../../../components/ui/card';
import { Skeleton } from '../../../components/ui/skeleton';

export function SettingsSkeleton() {
  return (
    <Container size="large" className="py-6 md:py-8">
      <Stack spacing="large">
        {/* Header Skeleton */}
        <div className="space-y-2">
          <div className="flex items-center gap-3">
            <Skeleton className="h-8 w-8" />
            <Skeleton className="h-8 w-48" />
          </div>
          <Skeleton className="h-4 w-64" />
        </div>

        {/* Tabs Skeleton */}
        <div className="space-y-6">
          {/* Tab List */}
          <div className="flex gap-2 border-b">
            {[1, 2, 3, 4].map((i) => (
              <Skeleton key={i} className="h-10 w-32" />
            ))}
          </div>

          {/* Content Cards */}
          <div className="space-y-6">
            <Card>
              <CardHeader>
                <Skeleton className="h-6 w-48" />
                <Skeleton className="h-4 w-64 mt-2" />
              </CardHeader>
              <CardContent className="space-y-4">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="space-y-2">
                    <Skeleton className="h-4 w-24" />
                    <Skeleton className="h-10 w-full" />
                  </div>
                ))}
                <Skeleton className="h-10 w-32" />
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <Skeleton className="h-6 w-48" />
                <Skeleton className="h-4 w-64 mt-2" />
              </CardHeader>
              <CardContent className="space-y-4">
                {[1, 2].map((i) => (
                  <Skeleton key={i} className="h-10 w-40" />
                ))}
              </CardContent>
            </Card>
          </div>
        </div>
      </Stack>
    </Container>
  );
}
